export enum SoftwarePackageName {
  Basic = 'Basic',
  Pro = 'Pro',
  Expert = 'Expert',
  PwsPortal = 'PWS Portal'
}
